import { render, staticRenderFns } from "./NewslistComponent.vue?vue&type=template&id=1201416b&scoped=true"
import script from "./NewslistComponent.vue?vue&type=script&lang=js"
export * from "./NewslistComponent.vue?vue&type=script&lang=js"
import style0 from "./NewslistComponent.vue?vue&type=style&index=0&id=1201416b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1201416b",
  null
  
)

export default component.exports